import { useAuth, useIsLogin } from '@/shared/context'
import { useGetCommonQuery } from '@/shared/queries/query/common.query'
import { useAppDispatch } from '@/shared/redux/hooks'
import {
  getListSystemKey,
  setAppInitialized,
  setListTabs,
  setUserInfo,
} from '@/shared/redux/slices/appGlobal.slice'
import identityService from '@/shared/services/IdentityService'
import { STORAGE, getAuthToken, getLocalStorage, setLocalStorage } from '@/shared/utils/storage'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { type ReactNode, useEffect } from 'react'

interface DefaultActionProps {
  children?: ReactNode
}

const DefaultAction = ({ children }: DefaultActionProps) => {
  const { isLogin } = useIsLogin()

  const { setUser } = useAuth()
  const dispatch = useAppDispatch()
  const queryClient = useQueryClient()

  const isLoginLocalStorage = getAuthToken()

  const { data: systemKeys, isLoading: isLoadingSystemKeys } = useGetCommonQuery()

  useEffect(() => {
    console.log('systemKeys', systemKeys)

    if (systemKeys) {
      console.log('systemKeys', systemKeys)
      dispatch(getListSystemKey(systemKeys))
    }
  }, [systemKeys, dispatch])

  const fetchTabs = async () => {
    try {
      const resp = await identityService.getTabs()
      return resp
    } catch (_error) {
      console.error('DefaultAction>>getListTab error:', _error)
      throw _error
    }
  }

  const { data, isLoading: isLoadingTabs } = useQuery({
    queryKey: ['tabs'],
    queryFn: fetchTabs,
    enabled: !!isLoginLocalStorage,
  })
  useEffect(() => {
    if (data?.isOk) {
      dispatch(
        setListTabs([
          {
            categoryId: 0,
            Description: 'Tổng Quan',
            isVisitTab: true,
          },
          {
            categoryId: -1,
            codeKey: 'MyTicket',
            description: 'MyTicket',
            isVisitTab: true,
          },
          ...data.object,
        ])
      )
    }
  }, [data, dispatch])
  useEffect(() => {
    // Auth-related logic (only load if user is logged in)
    if (isLogin) {
      setLocalStorage(
        STORAGE.DEV_MODE,
        !!(typeof window !== 'undefined' && (window as any).env?.API_ROOT)?.IS_DEV
      )

      // ponytail: BE không có route getInfo tương ứng — login đã lưu đủ user info vào
      // STORAGE.USER_INFO (xem use-login.ts), đọc lại từ đó thay vì gọi API thừa
      const userInfo = getLocalStorage(STORAGE.USER_INFO)
      if (userInfo) {
        dispatch(setUserInfo(userInfo))
        setUser(userInfo)
      }
    }
  }, [dispatch, isLogin, setUser])

  useEffect(() => {
    // App is initialized once GetSystemKey + GetListTab have both settled (success or
    // error) — isLoading is false both when a query resolves and when it's disabled
    // (isLoginLocalStorage falsy, so the tabs query never runs).
    if (isLoadingSystemKeys || isLoadingTabs) return

    dispatch(setAppInitialized(true))
  }, [dispatch, isLoadingSystemKeys, isLoadingTabs])

  useEffect(() => {
    // Tab để idle lâu → connection giữ có thể đã bị NAT/router âm thầm drop mà browser
    // không biết. Khi tab active lại, ping nhẹ để ép mở connection mới, phát hiện sớm
    // trước khi user bấm Save (lúc đó mới phát hiện thì đã ERR_CONNECTION_TIMED_OUT).
    if (!isLogin) return
    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        queryClient.refetchQueries({ queryKey: ['tabs'] }).catch(() => {})
      }
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => document.removeEventListener('visibilitychange', onVisible)
  }, [isLogin, queryClient])

  // ponytail: SignalR car-detection notification wiring removed with qlrv features; no TXNG equivalent yet
  return <>{children}</>
}

export default DefaultAction
